/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEnrollment} from '../api'

 export const useQueryGetEnrollment = createReactQueryHook('getEnrollment', getEnrollment)
